<template>
  <ModuleContainer v-bind="bindModule">
    <template #draggable>
      <DraggablePopup
        :height="400"
        :is-resizable="false"
        :show.sync="dialog.show"
        :title="$t('sidebar.layer-group.name')"
        :width="300"
        :top="10"
        :left="410"
        @close="onDialogClose"
      >
        <base-form
          ref="form"
          class="pa-4"
          lazy-validation
          @submit.stop="onSubmit"
        >
          <LayerGroupLayerList v-model="dialog.data.layers" />
        </base-form>
        <template #footer>
          <div class="d-flex pa-2">
            <v-spacer></v-spacer>
            <base-button
              text
              @click="onSubmit()"
              :disabled="!dialog.data.layers.length"
            >
              {{ $t('actions.apply') }}
            </base-button>
          </div>
        </template>
      </DraggablePopup>
    </template>

    <slot />
  </ModuleContainer>
</template>

<script>
import ModuleMixin from '@components/Map/mixins/ModuleMixin'

import LayerGroupLayerList from '@views/layer-group/layer-group-layer-list.vue'
import { DraggablePopup } from '@components/draggable'
import { API_LAYERGROUP } from '@/src/service/api'
export default {
  components: { DraggablePopup, LayerGroupLayerList },
  mixins: [ModuleMixin],
  data: (vm) => ({
    dialog: {
      show: false,
      loading: false,
      data: { layers: [] },
      error: {},
    },
  }),

  methods: {
    open(layerGroup, item) {
      this.layerGroup = layerGroup
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.$set(this.dialog, 'data', Object.assign({}, item))
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: { layers: [] },
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        if (data.layers) {
          data.layer_ids = data.layers.map((x) => x.id)
          data.layers = []
        } else {
          data.layer_ids = []
        }
        this.dialog.loading = true
        let res = await API_LAYERGROUP.update(data.workspace_id, data.id, data)
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
        this.callAction('reset')
      } finally {
        this.dialog.loading = false
      }
    },
    callAction(type) {
      this.$emit('layer:action', { type, layer: this.layerGroup })
    },
  },
}
</script>
